import ProductListView from "@/views/admin/products/ProductListView";

const meta = { middleware: ["auth"], roles: ["admin", "super_admin"] };

export default [
    {
        name: "admin.products",
        path: "products",
        component: ProductListView,
        meta,
    },
];
